import { render, staticRenderFns } from "./AvatarEditDialog.vue?vue&type=template&id=b7852580"
import script from "./AvatarEditDialog.vue?vue&type=script&lang=js"
export * from "./AvatarEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports